import React, { useCallback, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import TabsNavbar from "../Common/TabsNavBar/TabsNavbar";
import { isDefined } from "../../Utils";
import DepotForms from "./DepotForms/DepotForms";
import Button from "../Common/FormElements/Button/Button";
import { closeRightModal } from "../../REDUX/actions/rightModal";
import {
  clearDepotData,
  createDepot,
  fetchDepotById,
  updateDepot,
} from "../../REDUX/actions/depot";
import { infoElements } from "./DepotForms/DepotInformations";
import { storekeeperForm } from "./DepotForms/data";
import LoaderWrapper from "../../Utils/ViewWrapper/LoaderWrapper/LoaderWrapper";

const DepotModal = ({ id }) => {
  const TABS = ["Informations", "Storekeepers", "Address"];
  const { t } = useTranslation("common");
  const dispatch = useDispatch();
  const { depot, createLoading, updateLoading, depotLoading } = useSelector(
    (state) => state?.depotReducer
  );

  const [activeTab, setActiveTab] = useState(TABS[0]);
  const [disabled, setDisabled] = useState(true);

  const [forms, setForms] = useState({
    infos: {},
    address: {},
    storekeepers: [],
  });

  const checkFormValidation = useCallback(() => {
    const updatedInvalidFields = [];
    infoElements?.forEach(({ name, required }) => {
      if (required) {
        if (
          forms.infos[name] === undefined ||
          forms.infos[name] === null ||
          !String(forms.infos[name])?.trim()?.length > 0
        ) {
          updatedInvalidFields.push(name);
        }
      }
    });
    forms.storekeepers?.forEach((storekeeper) => {
      storekeeperForm.forEach(({ name, required, userField }) => {
        if (required) {
          if (userField) {
            if (
              storekeeper?.user[name] === undefined ||
              storekeeper?.user[name] === null ||
              !String(storekeeper?.user[name])?.trim()?.length > 0
            ) {
              updatedInvalidFields.push(name);
            }
          } else {
            if (
              storekeeper[name] === undefined ||
              storekeeper[name] === null ||
              !String(storekeeper[name])?.trim()?.length > 0
            ) {
              updatedInvalidFields.push(name);
            }
          }
        }
      });
    });
    if (updatedInvalidFields?.length > 0) {
      setDisabled(true);
    } else {
      setDisabled(false);
    }
  }, [forms]);

  const handleClick = async () => {
    const data = {
      ...forms.infos,
      storekeepers: forms.storekeepers,
    };
    if (depot?.id) {
      dispatch(
        updateDepot(depot?.id, data, t, () => dispatch(closeRightModal()))
      );
    } else {
      dispatch(createDepot(data, t, () => dispatch(closeRightModal())));
    }
  };

  useEffect(() => {
    checkFormValidation();
  }, [checkFormValidation]);

  useEffect(() => {
    if (isDefined(id)) {
      dispatch(fetchDepotById(id));
    }
    return () => dispatch(clearDepotData());
  }, [id, dispatch]);

  useEffect(() => {
    if (isDefined(depot)) {
      setForms({
        infos: {
          id: depot?.id,
          name: depot?.attributes?.name,
          code: depot?.attributes?.code,
          email: depot?.attributes?.email,
          phone: depot?.attributes?.phone,
        },
        storekeepers:
          depot?.attributes?.storekeepers?.data?.map((el) => ({
            id: el?.id,
            name: el?.attributes?.name,
            role: el?.attributes?.role,
            user: {
              id: el?.attributes?.user?.data?.id,
              email: el?.attributes?.user?.data?.attributes?.email,
            },
          })) || [],
      });
    }
  }, [depot]);

  return (
    <div className="newRevendeur d-flex flex-column justify-content-between h100 min-w-1110px">
      <div className="flex-1 d-flex flex-column">
        <div className="alignH align-items-end">
          <h2 className={`sBold f25 quickSand text-blue ${"px-5"} mb-5`}>
            {id ? t("Modify the depot") : t("Add a depot")}
          </h2>
        </div>
        <TabsNavbar
          tabs={TABS}
          activeTab={activeTab}
          setActiveTab={setActiveTab}
          className={TABS?.length > 5 ? "gap-3" : "gap-5"}
          disabledIndex={isDefined(id) ? null : 2}
        />
        <LoaderWrapper loading={depotLoading}>
          <DepotForms activeTab={activeTab} forms={forms} setForms={setForms} />
        </LoaderWrapper>

        <div className="buttonsContainer d-flex justify-content-center mt-auto">
          <Button
            variant="outline"
            className="me-4"
            onClick={() => dispatch(closeRightModal())}
          >
            {t("Cancel")}
          </Button>
          <Button
            loading={createLoading || updateLoading}
            disabled={disabled}
            onClick={createLoading || updateLoading ? undefined : handleClick}
          >
            {t("Save")}
          </Button>
        </div>
      </div>
    </div>
  );
};

export default DepotModal;
